<ng-container *ngIf="airFlexibilitySearchForm && flexibilityFieldSpec">
    <h2 class="form-title">{{ wording.flexibility }}</h2>
    <form [formGroup]="airFlexibilitySearchForm">
        <combobox-field
                [items]="flexibilityItems"
                [fieldConfig]="flexibilityFieldSpec"
        ></combobox-field>
    </form>
</ng-container>

